import React from 'react'
import AccountInfoContent from './Ui/Blocks/AccountInfoContent'

const AccountInformation = () => {
  return <AccountInfoContent />
}

export default AccountInformation
